import React from 'react';
import TextField from '@mui/material/TextField';
import { SS_OUTLINED_INPUT, detailReadOnlyFieldSx } from '../storeDetailsConstants';

export function DetailReadOnlyField({ label, value, fullWidth = true, multiline = false }) {
  return (
    <TextField
      label={label}
      className={`${SS_OUTLINED_INPUT} store-details-readonly-field`}
      size="small"
      value={value ?? '—'}
      fullWidth={fullWidth}
      multiline={multiline}
      minRows={multiline ? 2 : undefined}
      tabIndex={-1}
      InputProps={{
        readOnly: true,
        tabIndex: -1,
      }}
      inputProps={{
        readOnly: true,
        tabIndex: -1,
        'aria-readonly': true,
      }}
      variant="outlined"
      sx={detailReadOnlyFieldSx}
    />
  );
}

function SettingsRow({ label, description, children, alignItems = 'flex-start' }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems,
        justifyContent: 'space-between',
        padding: '14px 18px',
        border: '1.5px solid #e4e7ec',
        borderRadius: 10,
        background: '#fff',
        marginBottom: 12,
        gap: 16,
      }}
    >
      <div style={{ minWidth: 0, flex: '1 1 auto' }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: '#181436', marginBottom: 3 }}>{label}</div>
        {description ? (
          <div style={{ fontSize: 12, color: '#6b7280', lineHeight: 1.5 }}>{description}</div>
        ) : null}
      </div>
      <div style={{ flexShrink: 0, minWidth: 120, textAlign: 'right' }}>{children}</div>
    </div>
  );
}

export function DetailFieldRow({ label, description, children, alignItems = 'flex-start' }) {
  return (
    <SettingsRow label={label} description={description} alignItems={alignItems}>
      {children}
    </SettingsRow>
  );
}

export function DetailValue({ children }) {
  return (
    <span style={{ fontSize: 14, fontWeight: 600, color: '#6b7280', wordBreak: 'break-word' }}>
      {children}
    </span>
  );
}
